import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Forbidden.css';

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className="forbidden-container">
      <div className="forbidden-content">
        <h1 className="forbidden-code">403</h1>
        <h2 className="forbidden-title">Access Denied</h2>
        <p className="forbidden-message">
          You don't have permission to view this page.
        </p>
        <button type="button" className="forbidden-btn" onClick={() => navigate('/')}>
          Go Home
        </button>
      </div>
    </div>
  );
};

export default Forbidden;
